import { Table } from '@nimbus-ds/components';
import { ProductTransferListResponseDto } from '@tiendanube/common';
import {
  TransferListHeader,
  TransferListRow,
  TransferListTableSkeleton,
} from './components';

interface TransferListTableProps {
  data: ProductTransferListResponseDto;
}

function TransferListTable({ data }: Readonly<TransferListTableProps>) {
  return (
    <Table>
      <TransferListHeader />
      <Table.Body>
        {data.map((transfer) => (
          <TransferListRow transfer={transfer} key={transfer.id} />
        ))}
      </Table.Body>
    </Table>
  );
}

TransferListTable.Skeleton = TransferListTableSkeleton;

export default TransferListTable;
